import { ComponentConfig, Slot } from '@measured/puck';

type ColumnRatio = '20/80' | '40/60' | '50/50' | '60/40' | '80/20';

type ColumnBlockProps = {
  leftColumn: Slot;
  rightColumn: Slot;
  columnRatio: ColumnRatio;
};

const getGridClasses = (ratio: ColumnRatio): string => {
  let gridClass = 'md:grid-cols-2';
  if (ratio !== '50/50') {
    gridClass = `md:grid-cols-5`;
  }
  return `grid grid-cols-1 ${gridClass} gap-4`;
};

const getColumnClasses = (ratio: ColumnRatio, position: 'left' | 'right'): string => {
  const baseClasses = 'flex flex-col gap-4 print:md:col-span-5';
  const classMap = {
    '20/80': { left: 'md:col-span-1', right: 'md:col-span-4' },
    '40/60': { left: 'md:col-span-2', right: 'md:col-span-3' },
    '50/50': { left: '', right: '' },
    '60/40': { left: 'md:col-span-3', right: 'md:col-span-2' },
    '80/20': { left: 'md:col-span-4', right: 'md:col-span-1' },
  };

  if (ratio in classMap) {
    return `${baseClasses} ${classMap[ratio][position]}`;
  }

  return baseClasses;
};

const ColumnBlock: ComponentConfig<ColumnBlockProps> = {
  label: 'Columns',
  fields: {
    columnRatio: {
      type: 'select',
      options: [
        { label: '20/80', value: '20/80' },
        { label: '40/60', value: '40/60' },
        { label: '50/50', value: '50/50' },
        { label: '60/40', value: '60/40' },
        { label: '80/20', value: '80/20' },
      ],
    },
    leftColumn: {
      type: 'slot',
    },
    rightColumn: {
      type: 'slot',
    },
  },
  defaultProps: {
    columnRatio: '50/50',
    leftColumn: [],
    rightColumn: [],
  },
  render: ({ leftColumn: LeftColumn, rightColumn: RightColumn, columnRatio }) => {
    return (
      <div className={getGridClasses(columnRatio)}>
        <LeftColumn className={getColumnClasses(columnRatio, 'left')} />
        <RightColumn className={getColumnClasses(columnRatio, 'right')} />
      </div>
    );
  },
};

export { ColumnBlock };
